/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Approval_Ask_Tool_Call_Create_External_BookingInputs */

const en_admin_ai_chat_approval_ask_tool_call_create_external_booking = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Create_External_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The assistant wants to create an external booking.`)
};

const de_admin_ai_chat_approval_ask_tool_call_create_external_booking = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Create_External_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Assistent möchte eine externe Buchung erstellen.`)
};

const es_admin_ai_chat_approval_ask_tool_call_create_external_booking = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Create_External_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El asistente quiere crear una reserva externa.`)
};

const fr_admin_ai_chat_approval_ask_tool_call_create_external_booking = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Create_External_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'assistant souhaite créer une réservation externe.`)
};

const nl_admin_ai_chat_approval_ask_tool_call_create_external_booking = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Create_External_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De assistent wil een externe boeking aanmaken.`)
};

const it_admin_ai_chat_approval_ask_tool_call_create_external_booking = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Create_External_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'assistente vuole creare una prenotazione esterna.`)
};

const pt_br2_admin_ai_chat_approval_ask_tool_call_create_external_booking = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Create_External_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O assistente quer criar uma reserva externa.`)
};

const pl_admin_ai_chat_approval_ask_tool_call_create_external_booking = /** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Create_External_BookingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asystent chce utworzyć rezerwację zewnętrzną.`)
};

/** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Create_External_BookingInputs) => LocalizedString} */
const hu_admin_ai_chat_approval_ask_tool_call_create_external_booking = en_admin_ai_chat_approval_ask_tool_call_create_external_booking;

/** @type {(inputs: Admin_Ai_Chat_Approval_Ask_Tool_Call_Create_External_BookingInputs) => LocalizedString} */
const ro_admin_ai_chat_approval_ask_tool_call_create_external_booking = en_admin_ai_chat_approval_ask_tool_call_create_external_booking;

/**
* | output |
* | --- |
* | "The assistant wants to create an external booking." |
*
* @param {Admin_Ai_Chat_Approval_Ask_Tool_Call_Create_External_BookingInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_approval_ask_tool_call_create_external_booking = /** @type {((inputs?: Admin_Ai_Chat_Approval_Ask_Tool_Call_Create_External_BookingInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Approval_Ask_Tool_Call_Create_External_BookingInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_approval_ask_tool_call_create_external_booking(inputs)
	if (locale === "de") return de_admin_ai_chat_approval_ask_tool_call_create_external_booking(inputs)
	if (locale === "es") return es_admin_ai_chat_approval_ask_tool_call_create_external_booking(inputs)
	if (locale === "fr") return fr_admin_ai_chat_approval_ask_tool_call_create_external_booking(inputs)
	if (locale === "nl") return nl_admin_ai_chat_approval_ask_tool_call_create_external_booking(inputs)
	if (locale === "it") return it_admin_ai_chat_approval_ask_tool_call_create_external_booking(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_approval_ask_tool_call_create_external_booking(inputs)
	if (locale === "pl") return pl_admin_ai_chat_approval_ask_tool_call_create_external_booking(inputs)
	if (locale === "hu") return hu_admin_ai_chat_approval_ask_tool_call_create_external_booking(inputs)
	return ro_admin_ai_chat_approval_ask_tool_call_create_external_booking(inputs)
});
export { admin_ai_chat_approval_ask_tool_call_create_external_booking as "admin.ai_chat.approval_ask_tool_call.create_external_booking" }